<template>
  <v-card
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    :class="cardClass"
    elevation="0"
    :style="cardStyle"
  >
    <v-card-title
      v-if="!noTitle"
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
      class="secondary--text text-h4 font-weight-bold avs-card-title"
    >
      <slot name="title">  </slot>
    </v-card-title>

    <v-card-subtitle
      v-if="subtitle"
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
      ><slot name="subtitle"> SUBTITLE </slot>
    </v-card-subtitle>

    <slot name="content"></slot>
  </v-card>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "Card",
  props: {
    cardClass: {
      type: String,
      default: "rounded-xl"
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardStyle() {
      return { backgroundColor: getTheme(this).bgCard }
    }
  }
}
</script>

<style>
.avs-card-title.v-card__title {
  display: block !important;
  width: 100%;
}
</style>
